<template>
    <div class="table-responsive">
        <table class="table table-light table-striped" :style="tableStyle">
            <caption class="caption-top visually-hidden" v-if="caption != ''">{{ caption }}</caption>
            <thead v-if="showHeader">
                <tr>
                    <th v-for="column in columns" :key="column.key" :style="column.columnStyle || {}"
                        :class="column.columnClass || []">                        
                        <slot :name="`header.${column.key}`" v-bind:column="column">
                            <div class="me-2">
                            <a v-if="column.sortable" @click.prevent="onColumnClick(column)" href="" class="link-dark">
                                {{ column.text }}
                            </a>
                            <span v-else>
                                {{ column.text }}
                            </span>
                            <i class="bi bi-arrow-up position-absolute" :class="isAscending(column) ? '' :'invisible'" v-tooltip="'Sorted asc'"></i>
                            <i class="bi bi-arrow-down position-absolute" :class="isDescending(column) ? '' :'invisible'" v-tooltip="'Sorted desc'"></i>
                        </div>
                        </slot>
                    </th>
                </tr>
            </thead>
            <tbody v-if="items != null && items.length > 0">
                <tr v-for="item in items" :key="item.id">
                    <td v-for="column in columns" :key="column.key" :style="column.style ? column.style(item) : {}"
                        :class="column != undefined && column.class != undefined ? column.class(item) : []"
                        class="align-middle">
                        <slot :name="`cell.${column.key}`" v-bind:column="column" v-bind:item="item">{{ column.value ?
                            column.value(item) : item }}</slot>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <td :colspan="columns.length">No data to display at this time</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup lang="ts">

import { ref, defineEmits, defineProps } from 'vue';
import { BTableColumn, BTableOptions } from "./BTable.types";

const props = withDefaults(defineProps<{
    items: any,
    columns: BTableColumn[],
    showHeader?: boolean,
    value: BTableOptions,
    caption: string,
    tableStyle?: string
}>(), {
    items: () => [],
    columns: () => [] as BTableColumn[],
    showHeader: true,
    value: () => ({
        totalItemCount: 0,
        itemsPerPage: 1,
        page: 1,
        sortBy: []
    }) as BTableOptions,
    caption: "",
    tableStyle: ""
});

var tableOptions = ref(props.value as BTableOptions);

const emit = defineEmits(['optionChange']);
function isAscending(column: BTableColumn): boolean {
    var s = tableOptions.value.sortBy[0];
    return s && s.key == column.key && !s.isDescending;
}

function isDescending(column: BTableColumn): boolean {
    var s = tableOptions.value.sortBy[0];
    return s && s.key == column.key && s.isDescending;
}

function onColumnClick(column: BTableColumn) {
    var s = tableOptions.value.sortBy[0];

    if (s && s.key == column.key) {
        if (s.isDescending) {
            tableOptions.value.sortBy = [];
        } else {
            tableOptions.value.sortBy[0].isDescending = true;
        }
    } else {
        tableOptions.value.sortBy = [
            {
                key: column.key,
                isDescending: false
            }
        ];
    }
    tableOptions.value.page = 1;

    emit("optionChange", tableOptions.value);
}

</script>
<style lang="scss">
.b-table {

    thead,
    tbody,
    tfoot,
    tr,
    td,
    th {
        min-width: max-content;
    }

    th {
        vertical-align: text-top;
    }
}
</style>
